import { Injectable, EventEmitter } from "@angular/core";
import * as _ from 'lodash';
import { VEHICLE_APPLICANT, VEHICLE_LOAN, VEHICLE_FINANCINGProcessing_type, VEHICLE_FINANCINGValue_type, VEHICLE_FINANCINGCommercial_title } from 'src/models/vehicle_loan.model';
import { base_phone_country_alpha2, base_employee_of_lender_types, XPRESS_APPLICANT, XPRESS_LOAN, XPRESS_ACCOUNT_TYPESACCOUNT_TYPETerm_type, XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type, account_type, XPRESS_LOAN_INFOStatus, XPRESS_ACCOUNT_TYPESACCOUNT_TYPE } from 'src/models/xpress_loan.model';
import { BASE_APPLICANTDeclined_answer_race_gender, CREDITCARD_APPLICANT, CREDITCARD_LOAN } from 'src/models/creditcard_loan.model';
import { PERSONAL_APPLICANT, PERSONAL_LOAN } from 'src/models/personal_loan.model';
import { APP_STATUSValue, FinalPageEnum } from 'src/models/common.model';
import { LoanTypeEnum } from 'src/models/loan-type.enum';
import { ApiService } from './api.service';
import { ApplicantLoanComponent } from 'src/app/applicant-loan/applicant-loan.component';
import { FinalPageComponent } from "src/components/final-page/final-page.component";
import * as moment from "moment";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { AppComponent } from "src/app/app.component";
import { HttpClient } from "@angular/common/http";
import { CommonService } from "./common.service";
import { environment } from "src/environments/environment";
import { DocuSignComponent } from "src/components/review-page/docu-sign/docu-sign.component";
import { Observable } from "rxjs";
import { FlowLoadingPopupComponent } from "src/components/flow-loading-popup/flow-loading-popup.component";
import { AtomicService } from "./atomic.service";
import { JSEncrypt } from 'jsencrypt';
import {  publicKey } from './config';


@Injectable(
  {
    providedIn: "root"
  }
)
export class NmaoWfService {

	$encrypt: any;
  flowLoadingDialog;
  didAddApprovedAccounts = false;

  constructor(private apiService: ApiService, private dialog: MatDialog, 
    private atomicService: AtomicService,
    private httpClient: HttpClient, private commonService: CommonService) {
      
      this.$encrypt = new JSEncrypt();
  }

   getTestXaByJson(jsonFile: string):Observable<any>{
      return this.httpClient.get('assets/xa_tests_json/'+ jsonFile)
  }

  async getCurrentStatus(loanId){
    var getCurrentStatusResult = await this.apiService.getCurrentStatus(loanId).toPromise();
    return getCurrentStatusResult;
  }



  symitarBookResult_check(symitarBookResult){
    var memberNumber = symitarBookResult?.OUTPUT?.XML?.APPLICATION?.AccountInfo?.AccountNumber;
    return memberNumber;
  }

   addApprovedAccount_setAppStatus(loanId,appStatus: XPRESS_LOAN_INFOStatus,  selectedFundingType: XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type, fundingSources: any, interestedAccounts: XPRESS_ACCOUNT_TYPESACCOUNT_TYPE[] ,submitHistoryId? : string){
    //new api here
    this.didAddApprovedAccounts = true;
    return this
    .httpClient
    .post(this.commonService.baseUrl + "/api/NmaoWf/update-loan-AddApprovedAccounts-SetStatus/"+loanId+`?submitHistoryId=${submitHistoryId}`, {status: appStatus, fundingType:selectedFundingType,fundingSources:fundingSources, interestedAccounts: interestedAccounts });
  }

  setAppStatusFragment(loanId,appStatus: APP_STATUSValue , submitHistoryId?: string){
    return this
    .httpClient
    .post(this.commonService.baseUrl + "/api/NmaoWf/set-status-fragment/"+loanId+"?submitHistoryId="+submitHistoryId, {status: appStatus});
  }


  // async setAppToInstantApprove(loanId){
  //   return this
  //   .httpClient
  //   .post(environment.soApiUrl + "xpressLoan/set-app-to-instant-approve", {loanId: loanId});
  // }

  async fundingCall(data, submitHistoryId?: string){
    this.showLoading("fundingCall..")
  try{
    var fundingCallResult = await this.apiService.fundDeposit(data, submitHistoryId).toPromise();
     return fundingCallResult;
  }catch{
    return null;
  }
    
  }

  async fundingCallResult_check(loanId,type: XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type ){
    this.showLoading("fundingCallCheck..")
   var fundingCallResultCheck = await this
    .httpClient
    .get(this.commonService.baseUrl + `/api/NmaoWf/check-funding-call-result/${loanId}/${type}`).toPromise() as any;
    return fundingCallResultCheck.result;
  }

  async symitarBook(appId,soResponses, submitHistoryId?: string){
        //call symitar-book
        this.showLoading("symitarBook..")
        var symitarBookResult = await this.apiService.symitarBook(appId, submitHistoryId).toPromise();
        soResponses.xpress.symitarBookOutputJson = symitarBookResult;
      return symitarBookResult;
  }

  async presentAtomic(appId, submitHistoryId? : string){

    if(AppComponent.direct_deposit_subtype &&  AppComponent.direct_deposit_answer == 'Yes'){
      var accountNumberRes = await this.atomicService.getAccountNumberApprovedAccount(appId, AppComponent.direct_deposit_subtype)
      .toPromise()
      .catch(error => { // (**)
        return null;
      });

      if(accountNumberRes){
        // var accountNumber = accountNumberRes._body;
        // if(accountNumberRes){
        await  this.atomicService.showAtomicDeposit(appId, accountNumberRes, AppComponent.direct_deposit_subtype, submitHistoryId)
      // }
    }
    }
  }

  

   async openDocuSign(appId, decisionAppId,selectedProducts, ) {

    var modal = await this.dialog.open(DocuSignComponent, {
      disableClose: true,
      scrollStrategy:  AppComponent.scrollStrategy,
      data: {
        selectedProducts: selectedProducts,
        appId: appId,
        decisionAppId: decisionAppId
      },
      panelClass: AppComponent.isDesktop ? 'col-md-12' : 'full-screen',
      autoFocus: false,
      hasBackdrop: true,
      
    });

    var docuSignResult = await modal.afterClosed().toPromise();

  }

  async getAndReflectAlloyFinalStatus(submitHistoryId){
    var alloyApp = await this
    .httpClient
    .get(this.commonService.baseUrl + `/api/Alloy/get-and-reflect-journey-application/${submitHistoryId}`).toPromise() as any;
    return alloyApp.completeOutcome;
  }

  displayFinalPage(finalPageEnum: FinalPageEnum, baseType = 1){
    this.hideLoading();
    FinalPageComponent.isLoading = false;
   
    if(baseType == 2 && finalPageEnum == FinalPageEnum.Congratulation){
      finalPageEnum = FinalPageEnum.Wait2Days
    }
    FinalPageComponent.finalPageEnum = finalPageEnum;
    ApplicantLoanComponent.currentStepId = 3;
    
  }

  displayFinalPageByAlloyCompleteOutcome(completeOutcome : string, baseType = 1){
    if(completeOutcome?.toLowerCase() == "approved"){
      this.displayFinalPage(FinalPageEnum.Congratulation, baseType);
    }else if (completeOutcome?.toLowerCase() == "denied"){
      this.displayFinalPage(FinalPageEnum.ErrorReceived, baseType);
    }else{
      this.displayFinalPage(FinalPageEnum.Wait2Days, baseType);
    }
  }


  async checkFraudOrDup(XAId: string, selectedFundingType){
    var currentStatus = await this.getCurrentStatus(XAId);
    if(currentStatus.status=='FRAUD'|| currentStatus.status=='DUP'){
       await this.addApprovedAccount_setAppStatus(XAId, 
        currentStatus.status=='FRAUD'?XPRESS_LOAN_INFOStatus.FRAUD: XPRESS_LOAN_INFOStatus.DUP, selectedFundingType,[],[]).toPromise()
      this.displayFinalPage(FinalPageEnum.Wait2Days);
      await this.setAppStatusFragment(XAId, currentStatus.status=='FRAUD'?APP_STATUSValue.FRAUD:APP_STATUSValue.DUP ).toPromise()
      return false;
    }
    return true;
  }


  showLoading(loadingMessage){
    if(!this.flowLoadingDialog || !this.flowLoadingDialog.componentInstance){
      this.flowLoadingDialog = this.dialog.open(FlowLoadingPopupComponent,
        {
          disableClose: true,
          scrollStrategy:  AppComponent.scrollStrategy,
          data:{
            loadingMessage: loadingMessage
          }
        })
    }else{
      //this.flowLoadingDialog.componentInstance.data =
      this.flowLoadingDialog.componentInstance.updateMessage(loadingMessage)
    }
    

  }

  hideLoading(){
    if(this.flowLoadingDialog){
      this.flowLoadingDialog.close()
    }
  }

  encryptRsa(jsonString){
    // const encryptRsa = new EncryptRsa();
    // const encryptedText = encryptRsa.encryptStringWithRsaPublicKey({ 
    //   text: jsonString,   
    //   publicKey:``,
    // });
    if (jsonString.length > 117){
      throw new Error("length should be smaller than 117 chars");
    }
    this.$encrypt.setPublicKey(publicKey);
    var cypherText = this.$encrypt.encrypt(jsonString);
    return cypherText
  }

}